var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 49,
    height: 49,
    rx: 24.5,
    fill: "#EDEDED"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7805_14752",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 14,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 14,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7805_14752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.725 35L19 28V26H22.5C23.3833 26 24.1458 25.7125 24.7875 25.1375C25.4292 24.5625 25.8167 23.85 25.95 23H18V21H25.65C25.3667 20.4167 24.9458 19.9375 24.3875 19.5625C23.8292 19.1875 23.2 19 22.5 19H18V17H30V19H26.75C26.9833 19.2833 27.1917 19.5917 27.375 19.925C27.5583 20.2583 27.7 20.6167 27.8 21H30V23H27.975C27.8417 24.4167 27.2583 25.6042 26.225 26.5625C25.1917 27.5208 23.95 28 22.5 28H21.775L28.5 35H25.725Z",
    fill: "#EA4335"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.c54409767b6e9d435131e1f62c6cbb28.svg";
export { ForwardRef as ReactComponent };